export const ANKLE_OEDEMA_OPTIONS = [
  { label: "Present", value: "yes" },
  { label: "Absent", value: "no" },
];

export const FETAL_PRESENTATION_OPTIONS = [
  { label: "Cephalic", value: "Cephalic" },
  { label: "Breech", value: "Breech" },
  { label: "Non-cephalic / Non-breech", value: "NonCephalicNonBreech" },
];

export const FETAL_ENGAGEMENT_OPTIONS = [
  { label: "1/5", value: "1/5" },
  { label: "2/5", value: "2/5" },
  { label: "3/5", value: "3/5" },
  { label: "4/5", value: "4/5" },
  { label: "5/5", value: "5/5" },
];

export const FOETAL_MOVEMENT_OPTIONS = [
  { label: "Present per palpation", value: "present_per_palpation" },
  { label: "Present per patient", value: "present_per_patient" },
  { label: "Decreased per patient", value: "decreased_per_patient" },
  { label: "Absent per palpation", value: "absent_per_palpation" },
  { label: "Absent per patient", value: "absent_per_patient" },
];

/*
 * Foetal heart (KIN-2072). The MNCMS spec (Messaging ANC v0.18, Table 1, "Foetal heart",
 * SNOMED 249042007 / LOINC 11615-2) allows exactly two values, "Present" and "Absent", and the
 * backend emits the stored string into the OBX verbatim — so the stored value has to be the
 * spec's own wording, not a yes/no code.
 *
 * This is the ONE list for the field. It previously had yes/no values here while
 * FoetalObservationSection declared its own local copy with the spec wording, which is how the
 * form and the read-only view drifted apart: the form saved "Present", the view decoded "yes".
 * Both the form and the view now read this list, so they cannot disagree again. Stored rows
 * still hold the older spellings — see normaliseFoetalHeart for the read-side mapping.
 */
export const FOETAL_HEART_OPTIONS = [
  { label: "Present", value: "Present" },
  { label: "Absent", value: "Absent" },
];

export const UTERINE_CONTRACTIONS_OPTIONS = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];
